































































































































import Vue from 'vue'
import { OauthService } from '@/services'
import OtpInput from './OtpInput.vue'
import { handleSuccessfulLogin, handleLoginError } from '../utils/LoginHelper'
import LoginUIAlert from '../components/LoginUIAlert.vue'
import { getHostAndDomain } from '../../util/helper'

const MoonLoader = () => import('@/pmd/components/MoonLoader.vue')

export default Vue.extend({
  name: 'LoginOTPScreen',
  components: {
    MoonLoader,
    OtpInput,
    LoginUIAlert
  },
  props: {
    email: {
      type: String,
      required: true,
    },
    password: {
      type: String,
      required: true,
    },
    emailMask: {
      type: String,
    },
    phoneMask: {
      type: String,
    },
    totpEnabled: {
      type: Boolean,
    },
    selectedCompanyId: {
      type: String
    },
    fromShopify: {
      type: Boolean
    }
  },
  data() {
    return {
      response: '',
      loading: false,
      domainCompanyId: null,
      firstTime: true,
      otpChannel: this.emailMask ? 'email' : this.totpEnabled ? 'totp' : 'phone',
      otpCode: '',
      backupCode: '',
      token: "",
      lastOtpSent: 0,
      allowOTPAfter: 30,
      otpAttempt: 0,
      userFeedback: '',
      firebaseError: false,
      isAutoChannelSwitch: false,
      maxAttemptsReached: false,
      backUpCodeEnabled: false
    }
  },
  computed: {
    isValidOtp() {
      return this.otpCode.length === 6
    }
  },
  watch: {
    otpChannel() {
      if (!this.isAutoChannelSwitch) {
        this.userFeedback = ''
        this.response = ''
      }
      this.isAutoChannelSwitch = false
    }
  },
  methods: {
    async submit() {
      if (this.firstTime && this.otpChannel !== 'totp') {
        return this.requestForOtp()
      }
      if (this.otpChannel === 'totp') {
        this.firstTime = false
      }
      return this.verifyOtp()
    },
    async requestForOtp() {
      if (this.loading || (this.firstTime === false && this.lastOtpSent !== this.allowOTPAfter)) {
        return
      }

      try {
        this.response = ''
        this.resetOtpInput()
        this.userFeedback = !this.firstTime ? 'Sending OTP...' : ''
        this.lastOtpSent = 0
        this.otpAttempt++
        this.loading = true

        const params = {
          ...getHostAndDomain(),
          email: this.email.trim(),
          password: this.password.trim(),
          deviceId: await this.$store.dispatch('getDeviceId'),
          deviceType: 'web',
          deviceName: navigator.userAgent,
          otpChannel: this.otpChannel
        } as { [key: string]: any }

        if (this.domainCompanyId && this.domainCompanyId !== 'YuTUZlUtrwBtvmgByZDW') {
          params.companyId = this.domainCompanyId || this.selectedCompanyId
        } else {
          params.companyId = this.selectedCompanyId
        }

        const response = await OauthService.loginWithEmail(params)
        this.userFeedback = `
          We have sent a security code (OTP) to your ${this.otpChannel === 'email' ? 'email address' : 'phone number'}.
          Please check your ${this.otpChannel === 'email' ? 'inbox' : 'phone'} for this code.
        `
        this.token = response.token
        this.firstTime = false
        this.lastOtpSent = 1
        this.changeCounter()
      } catch (error) {
        const { errorMessage, errorType, maxAttemptsReached } = handleLoginError(error, this.email)
        this.maxAttemptsReached = maxAttemptsReached
        !this.maxAttemptsReached && this.switchOtpChannel(errorMessage)
        if(errorType === 'firebase-connection-error') {
          this.firebaseError = true
        }
      } finally {
        this.loading = false
      }
    },
    switchOtpChannel(errorMessage: string) {
      if (this.emailMask && this.phoneMask) {
        const newOtpChannel = this.otpChannel === 'email' ? 'phone' : 'email'
        this.isAutoChannelSwitch = true
        this.response = `We couldn't send an OTP to your ${this.otpChannel}. Would you like to receive the OTP via ${newOtpChannel} instead?`
        this.changeOtpChannel(newOtpChannel)
      } else {
        this.response = errorMessage
      }
    },
    switchBackUpCode() {
      this.backUpCodeEnabled = !this.backUpCodeEnabled
      this.response = ''
    },
    async verifyOtp() {
      try {
        this.loading = true
        this.response = ''
        this.userFeedback = this.otpCode ? 'Verifying OTP...' : 'Sending OTP...'

        const params = {
          ...getHostAndDomain(),
          email: this.email.trim(),
          password: this.password.trim(),
          deviceId: await this.$store.dispatch('getDeviceId'),
          deviceType: 'web',
          deviceName: navigator.userAgent,
          otpChannel: this.otpChannel,
          otp: this.otpCode,
          token: this.token,
          backupCode: this.backUpCodeEnabled
        } as { [key: string]: any }

        if (this.domainCompanyId && this.domainCompanyId !== 'YuTUZlUtrwBtvmgByZDW') {
          params.companyId = this.domainCompanyId || this.selectedCompanyId
        } else {
          params.companyId = this.selectedCompanyId
        }

        const response = await OauthService.loginWithEmail(params)

        this.userFeedback = 'Getting your account ready...'

        await handleSuccessfulLogin(response, this.$store, this.$router)

        this.userFeedback = 'Redirecting to your account...'
      } catch (error) {
        const { errorMessage, errorType } = handleLoginError(error, this.email)
        this.response = errorMessage

        if(errorType === 'firebase-connection-error') {
          this.firebaseError = true
        }
        this.resetOtpInput()
      } finally {
        this.loading = false
      }
    },
    handleOnChange(value) {
      this.otpCode = value
    },
    handleOnComplete(value) {
      this.otpCode = value
      this.submit()
    },
    resetOtpInput() {
      this.otpCode = ''
      this.userFeedback = ''
      if(this.$refs.otpInput1) {
        (this.$refs.otpInput1 as any).clearInput()
      }
    },
    changeCounter() {
      if (this.lastOtpSent && this.lastOtpSent < this.allowOTPAfter) {
        this.lastOtpSent++
        setTimeout(this.changeCounter, 1000)
      }
    },
    changeOtpChannel(option: 'email' | 'phone' | 'totp') {
      this.firstTime = true
      this.backUpCodeEnabled = false
      this.otpChannel = option
      if (option === 'totp') {
        this.firstTime = false
      }
    },
    async submitWithBackupCode() {
      this.otpCode = this.backupCode
      if (this.otpCode.length === 10) {
        await this.verifyOtp()
      } else {
        this.userFeedback = 'Please enter a valid backup code'
      }
    }
  },
})
